import { render, staticRenderFns } from "./DifficultyStars.vue?vue&type=template&id=7b9cb8fd&scoped=true"
import script from "./DifficultyStars.vue?vue&type=script&lang=js"
export * from "./DifficultyStars.vue?vue&type=script&lang=js"
import style0 from "./DifficultyStars.vue?vue&type=style&index=0&id=7b9cb8fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9cb8fd",
  null
  
)

export default component.exports